import { Link } from "react-router-dom";

import DefRoutes from "../../routes/routes.json";
import t from "../../i18n/i18n";
import initPage from "../../utils/initPage";

import Template from "../../template/template";
import UserInfo from "./userInfo/userInfo";
import ExpiresInfo from "./expiresInfo/expiresInfo";
import Benefits from "./benefits/benefits";

function LoyalMember() {
  initPage({ title: t("LoyalMember.Title"), theme: { background: "loyal-bg" } });

  return (
    <Template>
      <div className="container">
        <div className="row">
          <div className="col-12">
            <div className="loyal-member-warp">
              {/* loyal-member-warp */}

              <div className="loyal-sidebar">
                <div className="mobile-side-btn">
                  <button type="button" className="side-toggle">
                    <i className="fal fa-cog"></i>
                  </button>
                </div>
                <div className="loyal-sideinner-main">
                  <span className="mb-bg-cover view-below990"></span>
                  <div className="loyal-sideinner">
                    <div className="loyal-close-side view-below990">
                      <button type="button" className="side-toggle-close">
                        <i className="fal fa-cog"></i>
                      </button>
                    </div>
                    <div className="side-bar-top">
                      <div className="side-bar-top-max">
                        <div className="top-header gutter-40">
                          <h2 className="text-uppercase">
                            <img src="/images/crown-large.png" alt="" />
                            {t("LoyalMember.Title")}
                          </h2>
                        </div>
                        <UserInfo />
                      </div>
                    </div>
                    <div className="loyal-expire gutter-40">
                      <ExpiresInfo />
                    </div>
                    <Benefits />
                  </div>
                </div>
              </div>

              <div className="loyal-contentwarp">
                <div className="loyal-contentinner">
                  <div className="content-hero">
                    <img src={t("Images.A015")} alt="" />
                  </div>
                  <div className="benefits-col">
                    <ul>
                      <li>
                        <div className="benefits-contentbox">
                          <div className="icon">
                            <img src="/images/cont-loyal-ico1.png" alt="" />
                          </div>
                          <div
                            className="benefits-title"
                            dangerouslySetInnerHTML={{ __html: t("LoyalMember.WhatIs") }}
                          />
                          <div className="readmore-link">
                            <Link to={DefRoutes.WhatsIsIt}>{t("General.See")}</Link>
                          </div>
                        </div>
                      </li>
                      <li>
                        <div className="benefits-contentbox">
                          <div className="icon">
                            <img src="/images/cont-loyal-ico2.png" alt="" />
                          </div>
                          <div
                            className="benefits-title"
                            dangerouslySetInnerHTML={{ __html: t("LoyalMember.WhatBenefits") }}
                          />
                          <div className="readmore-link">
                            <Link to={DefRoutes.Benefits}>{t("General.See")}</Link>
                          </div>
                        </div>
                      </li>
                      <li>
                        <div className="benefits-contentbox">
                          <div className="icon">
                            <img src="/images/cont-loyal-ico3.png" alt="" />
                          </div>
                          <div
                            className="benefits-title"
                            dangerouslySetInnerHTML={{ __html: t("LoyalMember.HowToBuy") }}
                          />
                          <div className="readmore-link">
                            <a href="/recharge-loyal-member">{t("General.See")}</a>
                          </div>
                        </div>
                      </li>
                    </ul>
                  </div>
                  <div className="content-activity">
                    <div className="activity-row">
                      <div className="col-12 col-header">
                        <h3>{t("LoyalMember.Activities")}</h3>
                      </div>
                      <div className="col-12 col-md-6 col-lg-4">
                        <figure>
                          <Link to={DefRoutes.DailyDraw}>
                            <img src={t("Images.A007")} alt="" />
                          </Link>
                        </figure>
                      </div>
                      <div className="col-12 col-md-6 col-lg-4">
                        <figure>
                          <a href="/recharge-cupons">
                            <img src={t("Images.A008")} alt="" />
                          </a>
                        </figure>
                      </div>
                      <div className="col-12 col-md-6 col-lg-4">
                        <figure>
                          <Link to={DefRoutes.Rewards}>
                            <img src={t("Images.A009")} alt="" />
                          </Link>
                        </figure>
                      </div>
                    </div>
                    <div className="activity-row">
                      <div className="col-12 col-header">
                        <h3>{t("LoyalMember.RoutineActivities")}</h3>
                      </div>
                      <div className="col-12 col-md-6 col-lg-4">
                        <figure>
                          <a href="#">
                            <img src={t("Images.A010")} alt="" />
                          </a>
                        </figure>
                      </div>
                      <div className="col-12 col-md-6 col-lg-4">
                        <figure>
                          <a href="#">
                            <img src={t("Images.A011")} alt="" />
                          </a>
                        </figure>
                      </div>
                      <div className="col-12 col-md-6 col-lg-4">
                        <figure>
                          <a href="#">
                            <img src={t("Images.A012")} alt="" />
                          </a>
                        </figure>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {/* loyal-member-warp */}
            </div>
          </div>
        </div>
      </div>
    </Template>
  );
}

export default LoyalMember;
